export default __webpack_public_path__ + "locales/hy-AM/Payments.json?hash=8317d489348a8f6a3f12ac72c2b72947";